import { useDispatch } from "react-redux";
import Footer from "../../SharedModule/components/Footer";
import { verifyModuleAccess } from "../../SharedModule/utils/accessUtils";
import { RiShareBoxFill } from "react-icons/ri";
import { Spinner } from "../../SharedModule/components/Spinner";
import {
  CLIENTS_ACTIVATE_ACCESS,
  CLIENTS_ALL_ROLES,
  HUBSPOT,
  ROUTE_CLIENTS,
  ROUTE_CLIENTS_DETAILS,
  ROUTE_CLIENTS_RELATIONSHIP_REVIEW,
} from "../../SharedModule/utils/constants";
import { ForbiddenPage } from "../../SharedModule/pages/ForbiddenPage";
import { useLocation, useNavigate, useParams } from "react-router";
import { setActiveTab } from "../../SharedModule/redux/reducers/uiShared.reducer";
import { useEffect } from "react";
import HeaderClientsModule from "../components/HeaderClientsModule";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { useClientDetails } from "../hooks/useClientDetails";
import { checkClientCreatedByCostCenter } from "../utils/clientsUtils";
import { useClientActivationActions } from "../hooks/useClientActivationActions";
import { dateFormatWithHours } from "../../SharedModule/utils/formatters";
import { resetScrollY } from "../../SharedModule/utils/pagesUtils";

export const ClientDetailPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { id } = useParams();

  // If there is no id, go to clients list
  if (!id) {
    navigate(ROUTE_CLIENTS);
  }

  const {
    ClientForHeaderInfo,
    activeUserId,
    isClientDetailInfoLoading,
    actualClientExternalData,
    clientDetails,
    userRolesList,
    rolesLoaded,
    isLoadingWorkInfo,
    clientRecurringBillings,
    clientWorkOrders,
    clientProjects,
  } = useClientDetails(Number(id));

  useEffect(() => {
    document.title = "The Hub - Client Information";

    dispatch(setActiveTab(ROUTE_CLIENTS_DETAILS));

    return () => {
      resetScrollY(globalThis.location.pathname);
    };
  }, []);

  const setBooleanDropdownValue = (property: boolean | null): any => {
    if (property === null) return null;
    return property ? "Yes" : "No";
  };

  const isExternalClient = () =>
    clientDetails?.isExternal || !!actualClientExternalData;

  const {
    Modal,
    modalProps,
    closeModal,
    deactivateModalPortal,
    isLoadingDeactivate,
    goToEditProfile,
    deactivateClientAction,
    reactivateClientAction,
    checkCouldSeeToggleStatusButton,
    couldSeeEditButton,
    getEditButtonLabel,
  } = useClientActivationActions(
    id,
    ClientForHeaderInfo,
    clientDetails,
    activeUserId,
    userRolesList,
    actualClientExternalData,
    isExternalClient,
    isLoadingWorkInfo,
    clientRecurringBillings,
    clientWorkOrders,
    clientProjects
  );

  return (
    <>
      <Modal closeModal={closeModal} {...modalProps} />
      {deactivateModalPortal}
      <div className="content">
        <HeaderClientsModule
          isLoadingPage={
            isClientDetailInfoLoading ||
            !rolesLoaded ||
            isLoadingWorkInfo ||
            isLoadingDeactivate
          }
          backFromRelationshipPage={
            location.state?.from === ROUTE_CLIENTS_RELATIONSHIP_REVIEW
          }
        />

        {(isClientDetailInfoLoading ||
          !rolesLoaded ||
          isLoadingWorkInfo ||
          isLoadingDeactivate) && (
          <Spinner
            style={{
              marginLeft: "50%",
              marginTop: "5%",
            }}
          />
        )}

        {!isClientDetailInfoLoading &&
          rolesLoaded &&
          !isLoadingWorkInfo &&
          !isLoadingDeactivate &&
          !verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) && (
            <ForbiddenPage />
          )}

        {!isClientDetailInfoLoading &&
          rolesLoaded &&
          !isLoadingWorkInfo &&
          !isLoadingDeactivate &&
          verifyModuleAccess(true, CLIENTS_ALL_ROLES, userRolesList) && (
            <form className="card entry-hour-box-background px-4 py-2 my-3">
              <div
                className="d-flex justify-content-between"
                style={{ margin: "1% 8%" }}
              >
                <h3 style={{ marginTop: "0.5rem" }}>Client Information</h3>
                {verifyModuleAccess(
                  true,
                  CLIENTS_ACTIVATE_ACCESS,
                  userRolesList
                ) && (
                  <div>
                    {couldSeeEditButton() && clientDetails?.isActive && (
                      <button
                        className="btn button-secondary"
                        type="button"
                        onClick={() => goToEditProfile()}
                      >
                        {getEditButtonLabel()}
                        {(isExternalClient() ||
                          checkClientCreatedByCostCenter(
                            ClientForHeaderInfo.companyName
                          )) && <RiShareBoxFill />}
                      </button>
                    )}
                    {checkCouldSeeToggleStatusButton(
                      clientDetails?.isActive
                    ) && (
                      <button
                        className="btn button-secondary-danger ms-3"
                        type="button"
                        onClick={() => deactivateClientAction()}
                      >
                        Deactivate Client
                      </button>
                    )}
                    {checkCouldSeeToggleStatusButton(
                      !clientDetails?.isActive
                    ) && (
                      <button
                        className="btn button-secondary-danger"
                        type="button"
                        onClick={() => reactivateClientAction()}
                      >
                        Reactivate Client
                      </button>
                    )}
                  </div>
                )}
              </div>

              <div className="row" style={{ margin: "0 8%" }}>
                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Client Alias Name{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.companyAliasName}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5"></div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Street Address{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.streetAddress}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Street Address 2{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.streetAddress2}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      City{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.city}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      State{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.state}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Postal Code{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.postalCode}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Country{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.country}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Phone Number{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.phoneNumber}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Website URL{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.websiteUrl}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Company Domain Name{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.companyDomainName}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Price Schedule{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.priceSchedule}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Relationship{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.relationship}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Industry{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.industry}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Original Source{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.originalSource}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Referred By{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.referredBy}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Lead Generation Source{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.leadGenerationSource}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Comprehensive Care Client{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={setBooleanDropdownValue(
                          clientDetails?.comprehensiveCareClient
                        )}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Continuous Innovation Client{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={setBooleanDropdownValue(
                          clientDetails?.continuousInnovationClient
                        )}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Purchase Order Required{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={setBooleanDropdownValue(
                          clientDetails?.purchaseOrderRequired
                        )}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Use Authorization{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={setBooleanDropdownValue(
                          clientDetails?.useAuthorization
                        )}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Custom Master Agreement{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.customMasterAgreement}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-3">
                  <div className="flex-column w-50 me-5">
                    <label className="col-form-label d-block">
                      Custom NDA{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.customNda}
                        disabled={true}
                      />
                    </label>
                  </div>
                  <div className="flex-column w-50 ms-5">
                    <label className="col-form-label d-block">
                      Legal Information Location{" "}
                      <input
                        type="text"
                        className="form-control form-control-sm common-input input-no-border"
                        value={clientDetails?.legalInformationLocation}
                        disabled={true}
                      />
                    </label>
                  </div>
                </div>

                <div className="d-flex p-0 mb-5">
                  <div className="flex-column w-100">
                    <label className="col-form-label d-block">
                      Legal Notes
                      <TextareaAutosize
                        minRows={1}
                        maxRows={5}
                        className="textarea-resize w-100 d-flex common-input input-no-border"
                        value={clientDetails?.legalNotes}
                        disabled={true}
                        style={{ height: "100px", resize: "none" }}
                      />
                    </label>
                  </div>
                </div>

                {clientDetails?.lastUpdateDate && (
                  <div className="d-flex p-0 my-3">
                    <span className="helper-title">
                      Last updated by{" "}
                      {clientDetails?.lastUpdateBy === HUBSPOT ||
                      clientDetails?.lastUpdateBy?.length === 0
                        ? HUBSPOT
                        : clientDetails?.lastUpdateBy}{" "}
                      on{" "}
                      {dateFormatWithHours(clientDetails?.lastUpdateDate ?? "")}{" "}
                      (ET) on{" "}
                      {clientDetails?.lastUpdateBy === HUBSPOT
                        ? HUBSPOT
                        : "The Hub"}
                    </span>
                  </div>
                )}
              </div>
            </form>
          )}
        <Footer />
      </div>
    </>
  );
};
